import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  AgentProfileDto,
  FRENCH_DEPARTMENTS_MAP,
  FRENCH_REGIONS,
  FrenchDepartment,
} from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
} from '@workspace/ng-aura';
import { AgentColumnKey } from './abstract-agents-data-table.component';
import { AgentsDataTableFilterComponent } from './filter/agents-data-table-filter.component';

@Component({
  selector: 'etxe-agents-data-table',
  templateUrl: './agents-data-table.shared.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    AvatarAuraComponent,
    TitleCasePipe,
    LowerCasePipe,
    AgentsDataTableFilterComponent,
  ],
})
export class AgentsDataTableComponent extends BaseDataTableCoreComponent<AgentProfileDto, AgentColumnKey> {
  readonly availableRegions = FRENCH_REGIONS;

  getPrimaryRegionName(agent: AgentProfileDto): string | null {
    const regionCode = agent.intervention?.primaryRegion;
    if (!regionCode) return null;
    const r = this.availableRegions.find((x) => x.code === regionCode);
    return r ? r.name : regionCode;
  }

  getCoveredDepartments(agent: AgentProfileDto): string[] {
    const zones = agent.intervention?.zones;
    if (!zones || zones.length === 0) return [];
    const depts: string[] = [];
    for (const zone of zones) {
      if (zone.departments) {
        depts.push(...zone.departments);
      }
    }
    return depts;
  }

  getDepartmentLabel(code: string): string {
    const info = FRENCH_DEPARTMENTS_MAP[code as FrenchDepartment];
    return info ? `${info.code} (${info.name})` : code;
  }

  getAllDepartmentsTooltip(agent: AgentProfileDto): string {
    const depts = this.getCoveredDepartments(agent);
    if (depts.length === 0) return '';
    return depts.map((d) => this.getDepartmentLabel(d)).join(', ');
  }
}
